/* eslint-disable prefer-promise-reject-errors */
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

const EVENT_FEATURE_LINKS_COUNT = 4;

export const FORM_FIELD = {
  EVENT: {
    name: 'event',
    rules: [{ required: true, message: 'This field is required' }],
    deserialize: (field, data) => {
      const value = data.eventId;
      return value ? { eventId: value } : null;
    },
    serialize: utils.relatedEntitySerializer,
  },
  EVENT_IMAGE: {
    name: 'image',
    label: 'Logo:',
    buttonText: 'CHOOSE A NEW LOGO',
    rules: [{ required: true, message: 'A logo is required' }],
    size: IMAGE_SIZE['600x400'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  EVENT_TOP_TITLE: {
    name: 'topTitle',
    label: 'Title:',
    placeholder: 'Enter the top part of the title',
    rules: [{ required: true, message: 'Top title is required' }],
  },
  EVENT_BOTTOM_TITLE: {
    name: 'bottomTitle',
    placeholder: 'Enter the bottom part of the title',
    rules: [{ required: true, message: 'Bottom title is required' }],
  },
  EVENT_SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Enter a subtitle for the event',
    rules: [{ required: true, message: 'Subtitle is required' }],
  },
  EVENT_URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter the event URL',
    rules: [
      { required: true, message: 'URL is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  },
  EVENT_FEATURE_LINKS: {
    name: 'featureLinks',
    type: 'array',
    deserialize: (field, data) => {
      const links = data[field.name];
      return { [field.name]: [...new Array(EVENT_FEATURE_LINKS_COUNT)].map((_, i) => links[i] || {}) };
    },
    serialize: (field, values) => {
      const links = values[field.name];
      return { [field.name]: links.filter(({ name, url }) => name && url) };
    },
  },
  EVENT_FEATURE_LINK_NAME: (num) => ({
    name: [num, 'name'],
    placeholder: 'Enter the link name',
    rules: [
      ({ getFieldValue }) => ({
        validator: ({ field }) => {
          const nameName = field.split('.');
          const urlName = nameName.slice(0, -1).concat(['url']);
          const name = getFieldValue(nameName);
          const url = getFieldValue(urlName);

          if (url && !name) {
            return Promise.reject('Name is required');
          }
          return Promise.resolve();
        },
      }),
    ],
  }),
  EVENT_FEATURE_LINK_URL: (num) => ({
    name: [num, 'url'],
    placeholder: 'Enter the URL',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      ({ getFieldValue }) => ({
        validator: ({ field }) => {
          const urlName = field.split('.');
          const nameName = urlName.slice(0, -1).concat(['name']);
          const name = getFieldValue(nameName);
          const url = getFieldValue(urlName);

          if (name && !url) {
            return Promise.reject('URL is required');
          }
          return Promise.resolve();
        },
      }),
    ],
  }),
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODE = {
  MANUAL: {
    value: 'manual',
    label: 'Add an event manually',
  },
  EXISTING: {
    value: 'existing',
    label: 'Add an existing event',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  featureLinks: [],
};
